export default __webpack_public_path__ + "static/media/user.31d6cfe0.svg";